import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Panel from '@/components/Panel';
import { Checkbox, Input, message } from 'antd'
import PadStack, { frontendPadstackHandle } from '../../../../services/helper/DB/padStackDB';
import Table from '../../../../components/EditableTable/EditableTable';
import { numberCheck } from '../../../../services/helper/dataProcess';
import PadStackDialog from './PadStackDialog'
import _ from 'lodash';
import { splitNumUnit } from '../../../../services/helper/numberHelper';
import { unitChange } from '../../../../services/helper/mathHelper';
import MaterialPanel from '@/components/Material';
import LayoutData from '@/services/data/LayoutData';
import { saveStackupToServer } from '../Stackup_v1/store/actionCreators';
import { METAL } from '../../../../services/Stackup';
import { NEW_MATERIAL } from '../../../../services/Stackup/Material';
import './index.css';
import { SINGLE_PAGE_LAYOUT } from '../../../../constants/layoutConstants';

const columns = [{
  title: 'Name',
  dataIndex: 'name',
  width: '30%',
  sorter: (a, b) => a.name.localeCompare(b.name)
}, {
  title: 'Via#',
  dataIndex: 'viaNum',
  width: '10%',
  sorter: (a, b) => Number(a.viaNum) > Number(b.viaNum) ? 1 : -1,
}, {
  title: 'Drill Type',
  dataIndex: 'holeType',
  width: '10%'
}, {
  title: 'Drill Size',
  dataIndex: 'holeParameter',
  width: '12%'
}, {
  title: 'Plating Thickness',
  dataIndex: 'plating',
  width: '18%',
}, {
  title: 'Material',
  dataIndex: 'material',
  width: '20%'
}];
const { Search } = Input;
const POLYGON = 'polygon', ROUNDRECT = 'roundrectangle', CIRCLE = 'circle', SQUARE = 'square', RECT = 'rectangle', OVAL = 'oval';
const unitList = ['%', 'mil', 'um', 'mm']

class PadStackInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      height: 493,
      showStackList: [],
      globalPlating: "",
      searchValue: '',
      errors: {},
      selectedVia: "",
      doNotUsePadstack: false,
      stackupData: {},
      multiSelectVis: [],
    };
    this.stackList = [];
    this.defaultStackList = [];
    this.defaultGlobalPlating = 20;
    this.defaultDoNotUsePadstack = false
    this.defaultStackupData = {}
  }

  async componentDidMount() {
    const { designId } = this.props;
    this.setDefaultColumns();
    document.addEventListener("click", this.handleClickOutside, true);
    LayoutData.getStackupJson({ pcbId: designId, reload: true, determineMetalLayer: true }).then(stackupData => {
      if (!stackupData || !stackupData.stackup) {
        return;
      }
      const _stackupData = stackupData.stackup
      this.setState({
        stackupData: _stackupData
      })
      this.defaultStackupData = JSON.parse(JSON.stringify(_stackupData));
    })

    const stack = await PadStack.getStack(designId);
    if (stack.getError) {
      message.error('Get PCB Padstack info error, please try again.');
      this.props.closePanel(designId);
    }
    const { editPadstack, globalPlating = "100", doNotUsePadstack = false } = stack;
    this.stackList = editPadstack;
    this.defaultStackList = JSON.parse(JSON.stringify(editPadstack));
    this.defaultGlobalPlating = globalPlating;
    this.defaultDoNotUsePadstack = doNotUsePadstack
    this.setState({
      loading: false,
      showStackList: editPadstack,
      globalPlating,
      doNotUsePadstack
    });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  setDefaultColumns = () => {
    columns[0].render = (text) => {
      return <div onClick={() => this.onShowVias(text)} className={`layout-padstack-via-name`}>
        <span>{text}</span>
      </div>
    }

    columns[4].render = (text) => {
      return text ? String(text).match(/^-?\d+(\.\d+)?$/ig) ? `${text}%` : text : '';
    }

    columns[4].onCell = (record) => {
      const { plating } = record;
      const { num, unit } = splitNumUnit(plating);
      const value = unit && unitList.includes(unit) ? num : plating
      return {
        record: { ...record, value, unit: unit && unitList.includes(unit) ? unit : '%' },
        edit: 'input-with-select',
        unitList,
        dataIndex: 'value',
        allowEmpty: true,
        decimals: 3,
        handleSave: (row) => this.savePlating(row)
      }
    }

    columns[3].render = (text, record) => {
      const { holeType } = record;
      const title = () => {
        switch (holeType) {
          case ROUNDRECT:
            return `Width = ${text[0]}, Height = ${text[1]}, cornerRadius = ${text[2]}`
          default:
            return text.join(', ')
        }
      }
      return text && text.length ? <span title={title()}>{text.join(', ')}</span> : '';
    }

    columns[3].onCell = (record) => {
      const { holeType } = record;
      return ![CIRCLE, SQUARE, RECT].includes(holeType) ? {
        edit: false,
      } : {
        record,
        edit: true,
        customInput: PadStackDialog,
        trigger: "pad-stack-dialog",
        dataIndex: "holeParameter",
        shapIndex: "holeType",
        dialogSave: this.saveHoleParameter,
        onClick: (e) => this.stopProps(e),
      }
    }

    columns[5].render = (text, record) => {
      const { stackupData } = this.state
      const materialList = stackupData.materials || []
      let _text = record.material;
      if (_text) {
        const index = materialList.findIndex(item => item.name === _text)
        if (index > -1) {
          const material = materialList[index]
          _text = `${material.name} ${material.sigma ? `(σ=${material.sigma})` : ''}`
        }
      }
      return <span title={_text}>{_text}</span>
    }

    columns[5].onCell = (record) => {
      const { material } = record;
      const { pageType } = this.props
      const { stackupData } = this.state
      const materialList = stackupData.materials || []
      return {
        record: { ...record, type: METAL },
        edit: true,
        editType: "padstack_material",
        customInput: MaterialPanel,
        materialList,
        dataIndex: 'material',
        text: material,
        closePanel: this.saveMaterial,
        pageType,
      }
    }
  }

  stopProps = (e) => {
    e && e.stopPropagation()
  }

  saveMaterial = ({ newMaterial, selectMaterialName, record }) => {
    const { stackupData, multiSelectVis } = this.state
    const { name } = record;
    const index = this.stackList.findIndex(item => item.name === name);
    if (index > -1) {
      let _materialList = [...stackupData.materials];
      this.stackList[index].material = selectMaterialName && newMaterial.name ? newMaterial.name : '';
      if (multiSelectVis.length && multiSelectVis.includes(name)) {
        // Apply Material to all selected Vias
        this.stackList.forEach(item => {
          if (multiSelectVis.includes(item.name)) {
            item.material = selectMaterialName && newMaterial.name ? newMaterial.name : '';
          }
        })
      }

      if (!selectMaterialName || !newMaterial.name) {
        this.getShowList();
        return;
      }
      //update material list
      if (selectMaterialName === NEW_MATERIAL) {
        _materialList.push({ ...newMaterial, via_use: true })
      } else if (!_materialList.find(item => item.name === selectMaterialName)) {
        _materialList.push({ ...newMaterial, via_use: true })
      } else {
        const _index = _materialList.findIndex(item => item.name === selectMaterialName);
        _materialList[_index] = { ...newMaterial, via_use: true };
        for (let item of this.stackList) {
          if (item.material === selectMaterialName) {
            item.material = newMaterial.name;
          }
        }
      }
      // layers
      const _layers = stackupData.layers.map((item) => {
        if (item.material === selectMaterialName) {
          return {
            ...item,
            material: newMaterial.name
          };
        }
        return item;
      })
      const _stackupData = {
        layers: _layers,
        materials: _materialList,
        unit: stackupData.unit,
        version: stackupData.version
      }
      this.setState({
        stackupData: _stackupData
      })
    }
  }

  closePanel = () => {
    const { designId } = this.props;
    const { globalPlating, selectedVia, doNotUsePadstack, stackupData } = this.state;
    const isEqual = _.isEqual(this.defaultStackList, this.stackList) && this.defaultGlobalPlating === globalPlating && this.defaultDoNotUsePadstack === doNotUsePadstack
    if (!isEqual) {
      // save
      try {
        const editPadstack = frontendPadstackHandle(this.stackList);
        PadStack.saveStack(designId, { editPadstack, globalPlating }, doNotUsePadstack)
      } catch (error) {
        console.error(error);
        message.error('Save padstack failed!');
      }
    }

    if (!_.isEqual(this.defaultStackupData, stackupData)) {
      const stackups = LayoutData.saveStackupJson(designId, {
        data: stackupData.layers,
        materialList: stackupData.materials,
        unit: stackupData.unit
      }, true);
      this.props.saveStackupToServer(stackups, designId);
    }

    this.props.onShowVias && this.props.onShowVias('', selectedVia);
    this.props.closePanel(designId);
  }

  changeGlobalPlating = (e) => {
    e && e.stopPropagation()
    this.setState({
      globalPlating: e.target.value
    })
  }

  search = (e) => {
    e && e.stopPropagation()
    this.setState({
      searchValue: e.target.value,
      loading: true
    }, () => {
      this.getShowList()
    })
  }

  getShowList = () => {
    const { searchValue } = this.state;
    this.setState({
      loading: false,
      showStackList: this.stackList ? this.stackList.filter(item => item.name.includes(searchValue)) : []
    });
  }

  savePlating = (row) => {
    const { name, unit, value } = row;
    const { multiSelectVis } = this.state;
    const index = this.stackList.findIndex(item => item.name === name);
    let newPlating = value ? unit !== '%' ? `${value}${unit}` : String(value) : ''
    if (index > -1) {
      this.stackList[index].plating = newPlating;
      if (multiSelectVis && multiSelectVis.length && multiSelectVis.includes(name)) {
        this.stackList.forEach(item => {
          if (multiSelectVis.includes(item.name)) {
            item.plating = newPlating;
          }
        })
      }
      this.getShowList();
      this.checkPlatingCheck(name, newPlating);
    }
  }

  checkPlatingCheck = (name, plating) => {
    if (!plating) {
      const { errors } = this.state;
      let _errors = { ...errors }
      delete _errors[name];
      this.setState({ errors: _errors })
    } else {
      const { unit } = splitNumUnit(plating);
      const _unit = unit && unitList.includes(unit) ? unit : ''
      _unit ? this.checkNumber(name, plating, true) : this.checkPrecent(name, plating)
    }
  }

  checkPrecent = (name, plating) => {
    const { errors } = this.state;
    let _errors = { ...errors }
    let error = numberCheck(plating);
    if (!error) {
      if (plating < 0 || plating > 100) {
        error = 'The value must between 0% and 100%.'
      }
    }
    if (!error) {
      delete _errors[name];
    } else {
      _errors[name] = `${name} - ${error}`;
    }
    this.setState({
      errors: _errors
    })
  }

  checkGlobalPlating = () => {
    const { globalPlating } = this.state;
    this.checkPrecent('Global Plating', globalPlating)
  }

  checkNumber = (name, plating, extraCheck) => {
    const index = this.stackList.findIndex(item => item.name === name);
    if (index > -1) {
      const { errors } = this.state;
      let _errors = { ...errors };
      const { num, unit } = splitNumUnit(plating);
      const _unit = unit && unitList.includes(unit) ? unit : ''
      let error = numberCheck(num);
      if (!error) {
        if (this.stackList[index].holeType === CIRCLE && extraCheck) {
          const holeParameter = this.stackList[index].holeParameter[0];
          if (holeParameter) {
            const { num: holeNum, unit: holeUnit } = splitNumUnit(holeParameter);
            const _holeUnit = holeUnit && unitList.includes(holeUnit) ? holeUnit : ''
            const _holeNum = unitChange({ num: holeNum, oldUnit: _holeUnit, newUnit: 'mm' }).number;
            const _num = unitChange({ num: num, oldUnit: _unit, newUnit: 'mm' }).number
            if (Number(_num) > (Number(_holeNum) / 2)) {
              error = `value must be less than half of Drill Size!`
            }
          }
        }
        if (!error) {
          delete _errors[name];
        } else {
          _errors[name] = `${name} - ${error}`;
        }
      } else {
        _errors[name] = `${name} - ${error}`;
      }
      this.setState({
        errors: _errors
      })
    }
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const dialogBox = document.getElementById("pad-stack-dialog");
    if (
      dialogBox &&
      dialogBox.children.length > 0 &&
      !dialogBox.contains(target)
    ) {
      return;
    }
  };

  onShowVias = (text) => {
    if (!this.props.onShowVias) {
      return
    }
    const { selectedVia } = this.state;
    const { layout, designId } = this.props;
    if (layout !== SINGLE_PAGE_LAYOUT && designId) {
      const newSelected = text === selectedVia ? '' : text;
      this.props.onShowVias(newSelected, selectedVia);
      this.setState({
        selectedVia: newSelected,
      })
    }

  }

  saveHoleParameter = (holeParameter, record) => {
    const { name } = record;
    const { multiSelectVis } = this.state;
    const index = this.stackList.findIndex(item => item.name === name);
    if (index > -1) {
      this.stackList[index].holeParameter = holeParameter;
      if (multiSelectVis && multiSelectVis.length && multiSelectVis.includes(name)) {
        this.stackList.forEach(item => {
          if (multiSelectVis.includes(item.name)) {
            item.holeParameter = holeParameter;
          }
        })
      }
      this.getShowList();
      for (let parameter of holeParameter) {
        this.checkNumber(name, parameter, false)
      }
    }
  }

  changeDoNotUsePadstack = () => {
    this.setState({
      doNotUsePadstack: !this.state.doNotUsePadstack
    })
  }

  updateMultiSelectVis = (key) => {
    this.setState({
      multiSelectVis: key
    })
  }

  render() {
    const { leftWidth, topWidth, defaultLeft, defaultTop, maxWidth, designId, maxHeight, isLayoutPage = true } = this.props;
    const { loading, showStackList, globalPlating, errors, selectedVia, doNotUsePadstack, multiSelectVis } = this.state;
    const positionProps = isLayoutPage ? {
      position: 'panel-top-left',
      left: leftWidth ? leftWidth : defaultLeft,
      top: topWidth ? topWidth : defaultTop,
      defaultLeft: 50
    } : {
      position: 'panel-center'
    }
    const rowSelection = {
      type: 'checkbox',
      selectedRowKeys: multiSelectVis,
      onChange: this.updateMultiSelectVis,
    };
    return (
      <Panel
        {...positionProps}
        title={'Via Padstack'}
        visible
        onCancel={() => this.closePanel()}
        width={maxWidth < 900 ? maxWidth : 900}
        className='menu-panel aurora-menu-panel-padstack layout-padstack-panel'
        draggable
        minHeight={200}
        minWidth={500}
        maxWidth={maxWidth}
        zIndex={isLayoutPage ? 10 : 2000}
        overflow='hidden'
        redirectDom={isLayoutPage ? `aurora-PCB-layout-content-${designId}` : 'root'}
      >
        <div className='layout-padstack-content'>
          <Search
            placeholder="Search via name"
            onChange={e => this.search(e)}
            style={{ width: 200 }}
            size='small'
          />
        </div>
        <div className='layout-padstack-content'>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={showStackList}
            rowKey="name"
            rowClassName={(record) => record.name === selectedVia ? 'layout-padstack-via-selected' : ''}
            size="small"
            loading={loading}
            scroll={maxHeight - 200 < showStackList.length * 40 ? { y: maxHeight - 200 } : {}}
          />
        </div>
        <div className='layout-padstack-content'>
          <div className='layout-padstack-content-left'>
            <Checkbox
              checked={doNotUsePadstack}
              onChange={this.changeDoNotUsePadstack}
            />
            <span className='padstack-opion-title'>
              Do not update padstack settings
            </span>
          </div>
          <div className='layout-padstack-content-right'>
            <span className='plating-thickness-title'>Global Plating Thickness</span>
            <Input
              onChange={e => this.changeGlobalPlating(e)}
              onBlur={this.checkGlobalPlating}
              value={globalPlating}
              addonAfter='%'
              size='small'
              className='plating-thickness-input'
            />
          </div>
        </div>
        {errors && Object.keys(errors) && Object.keys(errors).length ? <div className='layout-padstack-content'>
          <div className='layout-padstack-content-error'>{Object.values(errors)[0]}</div>
        </div> : null}
      </Panel>
    )
  }
}

const mapState = (state) => {
  return {}
}

const mapDispatch = (dispatch) => ({
  saveStackupToServer(stackupData, designID) {
    dispatch(saveStackupToServer(stackupData, designID))
  },
})

export default connect(mapState, mapDispatch)(PadStackInfo);